/** @format */
import { MarketCode } from '@mpb-com/feather/enums';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Milliseconds } from '@toucan/client/global/application';

import { getPriceModifierGroups } from '@toucan/client/core/model';

export const usePriceModifierGroups = (
    modelId: number | null,
    market: MarketCode,
    options: Pick<UseQueryOptions, 'enabled'> = { enabled: true }
) => {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery({
        ...options,
        enabled: Boolean(modelId) && options.enabled,
        queryKey: ['price-modifier-groups', modelId],
        queryFn: () => {
            if (modelId) {
                return getPriceModifierGroups(modelId, market);
            }
            return [];
        },
        select: (data) => {
            // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
            data.sort((a, b) => a.name.localeCompare(b.name));
            data.forEach((item) => {
                // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
                item.modifiers.sort((a, b) => a.name.localeCompare(b.name));
            });

            return data;
        },
        staleTime: Milliseconds.ONE_HOUR,
    });
};
